<form [formGroup]="form" (ngSubmit)="submit()" class="mt-6 mx-4 sm:mx-0">
  <div class="mt-4">
    <div class="grid md:grid-cols-2 gap-2 mt-2">
      <!--div class="flex flex-col col-span-2">
        <label class="soft-label top required">Tätigkeit</label>
        <soft-select formControlName="task" softFieldValidation>
          @for (task of this.tasks(); track task.id) {
          <soft-select-option [value]="task.id + ''"
            >{{ task.description }}
          </soft-select-option>
          }
        </soft-select>
      </div-->

      @if (hasCalendarEvent()) {
      <div class="flex flex-col">
        <label class="soft-label top required">Startdatum</label>
        <soft-date-input formControlName="beginDay" softFieldValidation></soft-date-input>
      </div>
      <div class="flex flex-col">
        <label class="soft-label top required">Startzeit</label>
        <soft-time-input
          formControlName="beginTime"
          softFieldValidation
        ></soft-time-input>
      </div>
      <div class="flex flex-col">
        <label class="soft-label top required">Enddatum</label>
        <soft-date-input formControlName="endDay" softFieldValidation></soft-date-input>
      </div>
      <div class="flex flex-col">
        <label class="soft-label top required">Endzeit</label>
        <soft-time-input formControlName="endTime" softFieldValidation></soft-time-input>
      </div>
      <div class="flex flex-col col-span-2">
        <label class="soft-label top required">Mitarbeiter</label>
        <soft-select formControlName="employee" softFieldValidation>
          @for (employee of this.resources(); track employee.id) {
          <soft-select-option [value]="employee.id + ''"
            >{{ employee['name'] }}
          </soft-select-option>
          }
        </soft-select>
      </div>
      <div class="flex flex-col col-span-2">
        <label class="soft-label top required">Status</label>
        <soft-select formControlName="state" softFieldValidation>
          @for (status of this.statuses; track status.id) {
          <soft-select-option [value]="status.id + ''"
            >{{ status.label }}
          </soft-select-option>
          }
        </soft-select>
      </div>
      <div class="flex flex-col col-span-2">
        <label class="soft-label top">Kommentar</label>
        <soft-multiline-input
          [lines]="5"
          formControlName="comment"
          softFieldValidation
        ></soft-multiline-input>
      </div>
      }
    </div>
  </div>
</form>

<div class="flex gap-2">
  <button
    type="button"
    class="soft-button secondary h-14 w-full mt-4"
    (click)="this.resolve('CANCEL')"
  >
    Abbrechen
  </button>
  <button
    type="submit"
    class="soft-button primary h-14 w-full mt-4"
    (keydown.enter)="submit()"
    (click)="submit()"
  >
    Speichern
  </button>
</div>
